<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
          Chess Association Nagpur Celebrates 101st International Chess Day
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img
      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
    />
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">

    <div class="row justify-content-between">
      <div class="col-md-12">

<ul class="list-style list-style1 mb-3">
  <li>Date: 20th July 2025</li>
  <li>Venue: G H Raisoni Education of Information Technology, Shraddha Park, Wadi-Hingna Link Road, Nagpur</li>
</ul>

<p>Chess Association Nagpur celebrated the 101st International Chess Day with great enthusiasm on 20th July 2025. The celebration began with a symbolic Cake Cutting Ceremony performed jointly by Veteran Chess Player Shri V.K. Shrivastava and enthusiastic young chess players of various age groups, in the presence of eminent dignitaries and guests.</p>
<h5 class="primary-purple"> Chief Guests & Dignitaries Present:</h5>
<ul class="list-style list-style1 mb-3">
  <li>Shri Rajesh Batwani – Prominent Businessman (Chief Guest)</li>

<li>Shri Girish Vyas – President, Chess Association Nagpur & Vice President, Maharashtra Chess Association</li>

<li>Shri Amit Gandhare – Director (Public Relations), Raisoni Education</li>

<li>Shri Amit Yenurkar – Director, MKH Sancheti Group</li>

<li>Shri Bhushan Shriwas – Secretary, Chess Association Nagpur</li>

<li>Shri S.S. Soman – Member, MCA Observer Committee</li>
</ul>
<h5 class="primary-purple"> Nagpur District Amateur Selection Chess Tournament 2025</h5>
<p>To mark the International Chess Day, Chess Association Nagpur, in association with G H Raisoni Sports & Cultural Foundation, Kalpana Prakash Welfare Foundation, and MKH Sancheti Group, organized the Nagpur District Amateur Selection Chess Tournament.</p>
<ul class="list-style list-style1 mb-3">
<li>Total Participants: 196</li>

<li>FIDE Rated Players: 77</li>

<li>Rounds: 9</li>

<li>Venue: G H Raisoni Education of IT, Wadi-Hingna Link Road, Nagpur</li>
</ul>
<p>The tournament was inaugurated by Chief Guest Shri Rajesh Batwani, along with other dignitaries. To add to the celebration, snack boxes were distributed to all participants by the Chess Association Nagpur.</p>
<h5 class="primary-purple">Prizes & Awards:</h5>
<p>Cash Prizes sponsored by MKH Sancheti Group for the Top 10 winnersTrophies & Medals for the Best Players in the following categories:</p>

<p>Under 7, 9, 11, 13, 15, 17, 19</p>

<p>Age Groups: 20–39 yrs, 40–60 yrs, and 60+ yrs</p>

<h5> Arbiters Panel:</h5>
<ul class="list-style list-style1 mb-3">
  <li>Chief Arbiter: FA Sagar Sakhare</li>
</ul>

<p>Assistant Arbiters:</p>



<ul class="list-style list-style1 mb-3">
<li>FA Bharti Dhote</li>
  <li>FA Amit Tembhurne</li>

<li>SNA Prayas Ambade</li>

<li>SNA Shrikant Bagde</li>

<li>SNA Shyam Agrawal</li>

<li>SNA Akash Rewatkar</li>

<li>Prathamesh Machave</li>
</ul>

<p>The event was a grand success and a true celebration of the spirit of chess in Nagpur!</p>


      </div>
      <div class="col-md-12">
        <div class="sec-title mt-4 text-center">
          <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="lightBox--gallery">
          <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
             <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp">
              <a href="Javascript:void(0);">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp"
                  alt="GHRSCF" title="GHRSCF" class="img-fluid"/>
                <div class="light-gallery-poster">
                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
